export default __webpack_public_path__ + "static/media/tonybaloneys.b49d76dc.jpeg";